import { Injectable } from '@angular/core';
import { CountryConfigurationService } from '../country/country-configuration';
import { ValidatorFn } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class DocumentMaskStrategy {
  constructor(private readonly countryConfig: CountryConfigurationService) {}

  getMask(countryCode: string | null): string {
    return this.countryConfig.getDocumentMask(countryCode);
  }

  getType(countryCode: string | null): string {
    return this.countryConfig.getDocumentType(countryCode);
  }

  getPlaceholder(countryCode: string | null): string {
    return this.countryConfig.getDocumentPlaceholder(countryCode);
  }

  getValidator(countryCode: string | null): ValidatorFn {
    return this.countryConfig.getDocumentValidator(countryCode);
  }
}
